<script setup lang="ts">
import { RouterView } from 'vue-router';
import { usePinLock } from '@/composables/usePinLock';

usePinLock();
</script>

<template>
  <main class="app-shell mx-auto flex min-h-screen w-full max-w-md flex-col px-4">
    <RouterView />
  </main>
</template>

<style scoped>
/*
 * Telegram draws its header (Back, collapse, menu) over the top of the Mini App in full-size
 * and fullscreen modes. The SDK publishes the two inset sets as CSS variables
 * (telegram/sdk.ts); outside Telegram both fall back to 0 and only the 1rem remains.
 */
.app-shell {
  padding-top: calc(
    1rem + var(--tg-viewport-safe-area-inset-top, 0px) +
      var(--tg-viewport-content-safe-area-inset-top, 0px)
  );
}
</style>
